import { Box, Theme } from "@mui/material";
import dayjs from "dayjs";
import ReactDOMServer from "react-dom/server";
import { ChartTooltipFormatterParams } from "src/components/Dashboard/interfaces/DashboardComponentParams";
import { formatNum } from "src/lib/number.helpers";

import { getStyles } from "../utils/styles";

export function dashboardBlockChartTooltipFormatter(params: ChartTooltipFormatterParams[], theme: Theme): string {
  const styles = getStyles(theme);

  const list = params;
  const first = list[0];

  const tooltipDate = dayjs(first.value[0] as unknown as string);
  const header = tooltipDate.format("HH:mm");

  const rows = list.map((param, index) => {
    const paramData = param.data as unknown[];
    const value = paramData[1] as number | undefined;

    return (
      <Box style={styles.popupRow2Cols} key={index}>
        <Box style={styles.popupCol}>
          <Box style={styles.row}>
            <Box style={getStyles(theme, param.color).box} />
            <Box style={styles.textPrimary}>{param.seriesName}</Box>
          </Box>
        </Box>

        <Box style={styles.popupCol}>
          <Box style={styles.textPrimaryBold}>{formatNum(value ?? 0)}</Box>
        </Box>
      </Box>
    );
  });

  return ReactDOMServer.renderToString(
    <Box>
      <Box style={styles.textSecondary}>{header}</Box>
      {rows}
    </Box>
  );
}
